import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, memo, useContext, useMemo } from "react";
const defaultPDFViewerContext = {
    scale: 0,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updateScale: ()=>{},
    numPages: 0,
    currentPage: 0,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    changePage: ()=>{},
    isOutlineOpen: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOutlineOpen: ()=>{}
};
const PDFViewerControlContext = /*#__PURE__*/ createContext(defaultPDFViewerContext);
export const PDFViewerControlProvider = /*#__PURE__*/ memo((param)=>{
    let { children, currentPage, changePage, numPages, setIsOutlineOpen, isOutlineOpen, updateScale, scale } = param;
    const value = useMemo(()=>({
            changePage,
            currentPage,
            isOutlineOpen,
            numPages,
            scale,
            setIsOutlineOpen,
            updateScale
        }), [
        changePage,
        currentPage,
        isOutlineOpen,
        numPages,
        scale,
        setIsOutlineOpen,
        updateScale
    ]);
    return /*#__PURE__*/ _jsx(PDFViewerControlContext.Provider, {
        value: value,
        children: children
    });
});
PDFViewerControlProvider.displayName = "PDFViewerControlProvider";
export const usePDFViewerControlContext = ()=>{
    const context = useContext(PDFViewerControlContext);
    if (context === defaultPDFViewerContext) {
        throw new Error("usePDFViewerControlContext must be used within a PDFViewerControlProvider");
    }
    return context;
};
